"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disasterSearchReducer = exports.disasterSearchActions = exports.TYPES = exports.PERMISSION_KEY = exports.INIT_STATE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'DisasterSearch';

// アクションタイプ
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // 遷移関連
  GO_MAIN: PREFIX + 'GoMain',
  GO_DETAIL: PREFIX + 'GoDetail',
  GO_UPDATE: PREFIX + 'GoUpdate',
  GO_DELETE: PREFIX + 'GoDelete',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // scrollTopを変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // 全状態を初期状態にする
  CLEAR: PREFIX + 'Clear',
  // 利用許可
  SET_PERMISSION: PREFIX + 'SetPermission'
};

// 表示コンテンツ
const CONTENTS = exports.CONTENTS = {
  SEARCH: 'search',
  DETAIL: 'detail',
  UPDATE: 'update',
  DELETE: 'delete'
};

// 利用許可属性
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  EDIT: 'edit'
};

// 初期State
const INIT_STATE = exports.INIT_STATE = {
  dispContent: '',
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  searchConditions: {
    trainingFlg: true,
    specifyPeriod: false,
    searchFuture: true
  },
  fixedConditions: {
    trainingFlg: true,
    specifyPeriod: false,
    searchFuture: true
  },
  searchResult: [],
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  selectDisasterNo: 0,
  permission: {
    [PERMISSION_KEY.EDIT]: false
  },
  search: false
};

// アクション定義
const disasterSearchActions = exports.disasterSearchActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DETAIL]: function () {
    return {
      selectDisasterNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      selectDisasterNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_DELETE]: function () {
    return {
      selectDisasterNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_PERMISSION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      flg: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.CLEAR);

// Reducer定義
const disasterSearchReducer = exports.disasterSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    search: false,
    fixedConditions: _objectSpread({}, state.searchConditions)
  }),
  [TYPES.GO_MAIN]: (state, action) => {
    let searchConditions;
    if (action.payload.search) {
      searchConditions = state.fixedConditions;
    } else {
      searchConditions = state.searchConditions;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.SEARCH,
      search: action.payload.search,
      searchConditions
    });
  },
  [TYPES.GO_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.DETAIL,
    selectDisasterNo: action.payload.selectDisasterNo
  }),
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.UPDATE,
    selectDisasterNo: action.payload.selectDisasterNo
  }),
  [TYPES.GO_DELETE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.DELETE,
    selectDisasterNo: action.payload.selectDisasterNo
  }),
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.SET_PERMISSION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    permission: {
      [action.payload.key]: action.payload.flg
    }
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);